<template>
  <div class="detail_container">
    <div class="detail_center" v-if="echartData.length">
      <!-- 图表 -->
      <div class="echart_content">
        <div class="chart"></div>
        <!-- 标签列表 -->
        <div class="label_content">
          <p
            class="label_item"
            v-for="clip in echartData"
            :key="clip.id"
            :class="{ active: clip.name === currentLabelId }"
            @click="clickLabel(clip)"
          >
            <i :style="{ background: clip.color }"></i>
            <span class="name Text_Over">{{ clip.name || defaultText }}</span>
            <span class="num">{{ clip.value || 0 }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 视频列表 -->
    <cl-video-list-play
      height="calc(100% - 185px)"
      :title="currentLabelTitle"
      :list="filterClipList"
      class="pb16"
    ></cl-video-list-play>
  </div>
</template>

<script>
export default {
  name: "video-analysis",
  props: {
    videoData: [],
  },
  data() {
    return {
      loading: false, // loading
      commonData: {}, // 公共数据
      echartData: [], // echarts数据
      defaultText: "-", // 默认占位符
      currentLabelId: "", // 当前选择的标签Id
      selectLabel: [], // 当前选择的标签
      labelStrAll: false, // 是否标签全选
      labelOption: [], // 标签选项列表
      myChart: null, // 图表
      currentLabelTitle: "", // 当前选择的标签名称
      dateRange: [], // 日期范围
    };
  },
  computed: {
    // 过滤标签下的短片列表
    filterClipList() {
      let list = this.videoData.find((i) => i.label === this.currentLabelId);
      if (!list) return [];
      return list.data;
    },
  },
  beforeDestroy() {
    this.myChart && this.myChart.dispose();
  },
  mounted() {
    this.handleEchartData();
  },
  methods: {
    // 处理echart数据
    handleEchartData() {
      this.echartData = [];
      let colorList = [
        "rgb(25, 140, 255)",
        "rgb(0, 209, 144)",
        "rgb(255, 68, 55)",
        "rgb(0, 209, 197)",
        "rgb(85, 142, 255)",
        "rgb(255, 101, 54)",
        "rgb(229, 53, 188)",
        "rgb(52, 181, 232)",
        "rgb(253, 198, 16)",
        "rgb(137, 85, 255)",
      ];
      this.echartData = this.videoData.map((item, colorIndex) => {
        let i = colorIndex < 10 ? colorIndex : parseInt(colorIndex % 10); // 标签颜色
        return {
          name: item.label, // 标签名称
          value: item.count, // 出现的次数
          color: colorList[i],
        };
      });
      this.echartData.sort((a, b) => b.value - a.value); // 降序-排序
      if (this.echartData && this.echartData.length) {
        this.currentLabelId = this.echartData[0].name;
        this.currentLabelTitle = this.echartData[0].name;
      }
      this.initEchart();
    },
    // echart 玫瑰🌹饼图
    initEchart() {
      let radius = [20, 75];
      let option = {
        grid: {
          top: "5%",
          right: "5%",
          bottom: "5%",
          left: "5%",
          containLabel: true,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: radius, // 饼图的半径 数组的第一项是内半径，第二项是外半径
            center: ["50%", "50%"], // 饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标
            roseType: "area", // 是否展示成南丁格尔图，通过半径区分数据大小 可选择两种模式 area or radius
            label: {
              show: true,
              position: "inner", // 标签的位置 outside inside center
              color: "#fff",
              fontSize: 14,
              formatter: (params) => params.data.realValue,
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            itemStyle: {
              color: (params) => params.data.color,
            },
            data: this.echartData.map((item) => {
              return {
                ...item,
                value: Math.pow(item.value, 0.35), // 指数0.099不变，底数越大，增长越平缓。
                realValue: item.value,
              };
            }),
          },
        ],
      };
      this.$nextTick(() => {
        let element = document.getElementsByClassName("chart")[0];
        if (!element) return;
        this.myChart = this.$echarts.init(element);
        this.myChart.setOption(option);
      });
    },
    // 点击标签时
    clickLabel(item) {
      this.currentLabelId = item.name;
      this.currentLabelTitle = item.name;
    },
  },
};
</script>

<style scoped lang="scss">
.detail_container {
  min-height: 240px;
  /deep/ .people_box {
    position: relative;
    top: -10px;
    padding: 0 0 0 55px;
  }
  .detail_center {
    height: 235px;
    margin-bottom: 16px;
    background: #fff;
    border-radius: $base-border-radius-mini;
    .echart_content {
      width: calc(100% + 32px);
      height: 180px;
      display: flex;
      .chart {
        width: 250px;
      }
      .label_content {
        width: calc(100% - 250px);
        overflow: hidden;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        padding-top: 24px;
        .label_item {
          width: 154px;
          height: 44px;
          margin: 0 32px 32px 0;
          padding: 0 16px;
          box-sizing: border-box;
          border-bottom: 1px solid $base-border-color-one;
          color: $base-font-major;
          display: flex;
          align-items: center;
          cursor: pointer;
          &:hover,
          &.active {
            background: #326a54;
            border-radius: 2px;
            color: #fff;
          }
          i {
            width: 14px;
            height: 14px;
            background: #198cff;
            border-radius: 2px;
            margin-right: 12px;
          }
          span.name {
            flex: 1;
            font-size: 14px;
          }
          span.num {
            font-size: 16px;
            font-family: "AkrobatMedium";
          }
        }
      }
    }
  }
}

/deep/ .video_list_container {
  margin: 0 16px;
  height: 400px !important;
}
</style>
